import { isDefined } from "@clipboard-health/util-ts";
import { Box, Stack } from "@mui/material";
import { CbhIcon, type CbhIconProps, Text } from "@src/appV2/redesign/system/ui-components";

interface PlacementSectionTemplateProps {
  title: string;
  titleRight?: React.ReactNode;
  iconType: CbhIconProps["type"];
  onTitleClick?: () => void;
  children?: React.ReactNode;
}

export function PlacementSectionTemplate(props: PlacementSectionTemplateProps) {
  const { title, titleRight, iconType, onTitleClick, children } = props;

  return (
    <Stack spacing={4} direction="row" flex={1}>
      <CbhIcon type={iconType} size="medium" />
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Text semibold variant="body1" sx={{ flex: 1, py: "3px" }} onClick={onTitleClick}>
            {title}
          </Text>
          {titleRight}
        </Stack>
        {isDefined(children) && <Box>{children}</Box>}
      </Stack>
    </Stack>
  );
}
